import { SupportFeedbackPostResultAjax } from './support-feedback.backend-model';
import { SupportFeedback } from './support-feedback.model';

export function transformSupportFeedback(
  feedback: SupportFeedbackPostResultAjax,
): SupportFeedback {
  return {
    id: feedback.id,
    supportTicketId: feedback.support_ticket_id,
    dateResolved: feedback.date_resolved * 1000,
    rating: feedback.rating,
    responsiveness: feedback.responsiveness,
    knowledge: feedback.knowledge,
    friendliness: feedback.friendliness,
    clarity: feedback.clarity,
    feedback: feedback.feedback,
  };
}
